// extracted by mini-css-extract-plugin
var _1 = "BsXiT elide";
var _2 = "TttxB";
var _3 = "DGq25";
export { _1 as "base", _2 as "block", _3 as "lineClamp" }
